export default function QrTable({ datas = [], loading = false, handlerowClick }) {
    return (
        <div className="bg-surface rounded-lg border-minimal">
            <table className="w-full text-center qrdata">
                <thead className="bg-gray-50 border-b border-border">
                    <tr>
                        <th>Batch Code</th>
                        <th>Batch Name</th>
                        <th>Qrcode Unique No.</th>
                        <th>Company Name</th>
                        <th>Scan Count</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        loading ? (
                            <tr>
                                <td colSpan="5" className="p-4 text-center">
                                    Loading...
                                </td>
                            </tr>
                        ) : datas.length === 0 ? (
                            <tr>
                                <td colSpan="5" className="p-4 text-center" >
                                    No records Found
                                </td>
                            </tr>
                        ) : (
                            datas.map((data) => {
                            let scanCount = data.scanCount > 0 ? <span className={`${data.scanCount > data.warning_limit ? "text-red-500" : "text-green-500" }`}>Scanned {data.scanCount} times</span> : data.scanCount                             

                             return (<tr key={data.id} className="border-t" onClick={() => handlerowClick(data.unique_no)}>
                                    <td>{data.batch_code}</td>
                                    <td>{data.batch_name || "N/A"}</td>
                                    <td>{data.unique_no}</td>
                                    <td>{data.company_name || "N/A"}</td>
                                    <td>{scanCount || "0"}</td>
                                </tr>
                            )}
                        )
                        )
                    }
                </tbody>
            </table>
        </div>
    )
}